export const months = [
  'Tammikuu',
  'Helmikuu',
  'Maaliskuu',
  'Huhtikuu',
  'Toukokuu',
  'Kesäkuu',
  'Heinäkuu',
  'Elokuu',
  'Syyskuu',
  'Lokakuu',
  'Marraskuu',
  'Joulukuu'
]

export const educationOptions = [
  {id: 'elementary_school', name: 'Peruskoulu'},
  {id: 'secondary_school', name: 'Lukio tai ammatillinen tutkinto'},
  {id: 'university', name: 'Korkeakoulututkinto'},
  {id: 'doctorate', name: 'Tohtori'},
  {id: 'something_else', name: 'Joku muu'}
]

export const maritalStatusOptions = [
  {id: 'single', name: 'Naimaton'},
  {id: 'married', name: 'Naimisissa'},
  {id: 'registered', name: 'Rekisteröidyssä parisuhteessa'},
  {id: 'cohabitation', name: 'Avoliitto'},
  {id: 'widow', name: 'Leski'},
  {id: 'divorced', name: 'Eronnut'},
  {id: null, name: 'Jätä tyhjäksi'}
]

export const moneySpentOptions = [
  {id: '0 - 1 000', name: '0 - 1 000'},
  {id: '1 000 - 5 000', name: '1 000 - 5 000'},
  {id: '5 000 - 10 000', name: '5 000 - 10 000'},
  {id: '10 000 - 50 000', name: '10 000 - 50 000'},
  {id: '50 000 - 100 000', name: '50 000 - 100 000'},
  {id: 'yli 100 000', name: 'yli 100 000'}
]

/*

  // const dropdownFavouriteParties: Pick<IParty, 'name' | 'id'>[] = createFavouritePartyOptions(parties, candidate)
  // dropdownFavouriteParties.push({name: 'En halua vastata', id: -1})

  export const createFavouritePartyOptions = (parties, candidate) => {
    let options = parties.filter((p: IParty) => p.id !== candidate.party_id && p.name !== 'Alman testipuolue')
    options = options.map(op => {
      switch (op.name) {
        case 'Kansallinen Kokoomus':
          return {
            ...op,
            name: 'Kokoomus'
          }
        case 'Suomen Sosialidemokraattinen Puolue':
          return {
            ...op,
            name: 'SDP'
          }
        case 'Suomen Kristillisdemokraatit': {
          return {
            ...op,
            name: 'Kristillisdemokraatit'
          }
        }
        default:
          return op
      }
    })
    const sorted = options.sort((a, b) => {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    })
    return sorted
  }





  // const SmallLabel = styled.span`
  //   font-size: 1.6rem;
  // `
  /* For ekv
        <Dropdown
          fieldKey={'id'}
          label={'Minkä puolueen kanssa menisit mieluiten hallitukseen?'}
          placeHolder={'Valitse'}
          onSelect={e => this.props.handleOnChange([e], 'favourite_parties')}
          options={dropdownFavouriteParties}
          displayField={'name'}
          value={
            Array.isArray(candidate.favourite_parties) && candidate.favourite_parties.length > 0
              ? candidate.favourite_parties[0]
              : undefined
          }
          selectionWidth={'330px'}
        /> 
        */
/* <Input
          type={'text'}
          width={'330px'}
          label={
            <>
              <span>Facebook-sivu,</span> <SmallLabel>esim. www.facebook.com/tilinnimi</SmallLabel>
            </>
          }
          onChange={e => this.props.handleOnChange(e, 'facebook')}
          value={candidate.facebook}
        /> */
/* <Input
          type={'text'}
          width={'330px'}
          label={
            <>
              <span>Twitter-tili,</span> <SmallLabel>esim. www.twitter.com/tilinnimi</SmallLabel>
            </>
          }
          onChange={e => this.props.handleOnChange(e, 'twitter')}
          value={candidate.twitter}
        /> */
